<!-- Addon for browser-update -->
<div class="buorg"
     id="buorg">
  <div class="buorg-pad"
       role="status"
       aria-live="polite">
    <b class="buorg-mainmsg">{{'SHARED.UNSUPPORTED-BROWSER-NOTIFICATION.MAIN' | translate}} </b>
    <span class="buorg-moremsg">{{'SHARED.UNSUPPORTED-BROWSER-NOTIFICATION.MORE' | translate}}</span>
  </div>
</div>
